import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { X } from 'lucide-react';
import { useSalesStore, SaleChannel, ShippingMethod, DeliveryStatus, SaleStatus } from '../../store/salesStore';

interface NewSaleModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const NewSaleModal = ({ isOpen, onClose }: NewSaleModalProps) => {
  const addSale = useSalesStore((state) => state.addSale);
  const [formData, setFormData] = useState({
    customer: '',
    amount: '',
    units: 1,
    status: 'Pendiente' as SaleStatus,
    shipping: 'Servientrega' as ShippingMethod,
    deliveryStatus: 'Pendiente' as DeliveryStatus,
    channel: 'Manual' as SaleChannel,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    addSale({
      date: new Date().toLocaleDateString(),
      ...formData,
    });
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-md rounded-xl bg-white p-6 w-full">
          <div className="flex items-center justify-between mb-4">
            <Dialog.Title className="text-lg font-medium">Nueva Venta</Dialog.Title>
            <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded">
              <X size={20} />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Cliente</label>
              <input
                type="text"
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#4D88FF] focus:ring-[#4D88FF]"
                value={formData.customer}
                onChange={(e) => setFormData({ ...formData, customer: e.target.value })}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Valor</label>
              <input
                type="number"
                required
                min="0"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#4D88FF] focus:ring-[#4D88FF]"
                value={formData.amount}
                onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Unidades</label>
              <input
                type="number"
                required
                min="1"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#4D88FF] focus:ring-[#4D88FF]"
                value={formData.units}
                onChange={(e) => setFormData({ ...formData, units: parseInt(e.target.value) })}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Estado del pago</label>
              <select
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#4D88FF] focus:ring-[#4D88FF]"
                value={formData.status}
                onChange={(e) => setFormData({ ...formData, status: e.target.value as SaleStatus })}
              >
                <option value="Pendiente">Pendiente</option>
                <option value="Pagado">Pagado</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Método de envío</label>
              <select
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#4D88FF] focus:ring-[#4D88FF]"
                value={formData.shipping}
                onChange={(e) => setFormData({ ...formData, shipping: e.target.value as ShippingMethod })}
              >
                <option value="Servientrega">Servientrega</option>
                <option value="Coordinadora">Coordinadora</option>
                <option value="Interrapidisimo">Interrapidisimo</option>
                <option value="TCC">TCC</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Canal de venta</label>
              <select
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#4D88FF] focus:ring-[#4D88FF]"
                value={formData.channel}
                onChange={(e) => setFormData({ ...formData, channel: e.target.value as SaleChannel })}
              >
                <option value="Manual">Manual</option>
                <option value="Chat">Chat</option>
                <option value="Web">Web</option>
              </select>
            </div>

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-sm font-medium text-white bg-[#4D88FF] hover:bg-[#4D88FF]/90 rounded-lg"
              >
                Guardar
              </button>
            </div>
          </form>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default NewSaleModal;